import { Link } from "gatsby"
import React from "react"
import { Button, RegBody, SemiBdTitle3 } from "@sr/gatsby-theme-ui"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"

const demoGraphic =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1692382325/pages/product/ProductVectorlightGray_btvcuw.svg"

export interface ProductEntryDemoProps {
  demo: boolean
}

const ProductEntryDemo = ({ demo }: ProductEntryDemoProps) => {
  if (!demo) return null

  return (
    <ProductEntryDemoStyled>
      <div className="product-entry-demo__container">
        <img className="product-entry-demo__graphic" src={demoGraphic} />
        <SemiBdTitle3 className="product-entry-demo__title">
          Let us help you operate smarter.
        </SemiBdTitle3>
        <RegBody className="product-entry-demo__body">
          Experience SmartRent solutions in action for yourself and see how our
          technology can help you streamline operations, improve site team
          efficiency, and elevate the resident experience.
        </RegBody>
        <Link
          className="product-entry-demo__link"
          to="/contact-smartrent/"
        >
          <Button
            btnColor="var(--button-secondary-bg)"
            btnTextColor="var(--button-secondary-text-color)"
            expand
          >
            <div className="product-entry-demo__button">Let's Talk</div>
          </Button>
        </Link>
      </div>
    </ProductEntryDemoStyled>
  )
}

export default ProductEntryDemo

const ProductEntryDemoStyled = styled.div`
  width: 100%;
  margin-top: ${rem(120)};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: var(--color-white);

  @media ${media.midUp} {
    margin-top: ${rem(176)};
  }

  .product-entry-demo__container {
    height: ${rem(374)};
    width: 100%;
    background: var(--color-gray900);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${rem(16)};
    position: relative;
    overflow: hidden;

    @media ${media.midUp} {
      height: ${rem(396)};
      gap: ${rem(24)};
    }

    @media ${media.stMidUp} {
      max-width: ${rem(1312)};
      border-radius: ${rem(8)};
    }

    .product-entry-demo__graphic {
      display: none;

      @media ${media.midUp} {
        display: block;
        position: absolute;
        height: ${rem(144)};
        object-fit: cover;
        object-position: left;
        width: auto;
        bottom: ${rem(30)};
        left: 50%;
        z-index: 1;
      }

      @media ${media.stMidUp} {
        left: auto;
      }
    }

    .product-entry-demo__title {
      z-index: 2;

      @media ${media.midUp} {
        font-size: ${rem(40)};
      }
    }

    .product-entry-demo__body {
      max-width: ${rem(277)};

      @media ${media.midUp} {
        max-width: ${rem(411)};
      }
    }

    .product-entry-demo__link {
      z-index: 2;
      margin-top: ${rem(16)};
      width: ${rem(191)};
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      color: white;
      text-decoration: none;
      background-color: var(--color-primary);
    }
  }
`
